import {render as renderAccordion} from './modules/accordion';

renderAccordion();
